export const achievementData = {
    bio : "Putting quantified achievements on a resume is great, but I just don’t work with hard numbers. I have no data to support the quality of my work. If you have lots of relevant experience, the heading statement of your resume will be a summary.",
    achievements : [
        {
            id : 1,
            title : 'Coding Ninjas',
            details : 'Data Strucutes in c++  Excellence Certificate . Finished at a top rank in the dsa course. ',
            date : 'aug 20, 2021',
            field : 'Computer Science',
            image : 'https://codingninjas.com/assets-landing/images/CNLOGO.svg'
        },
        {
            id : 2,
            title : 'Meta-Hackercup Qualifier',
            details : 'Qualified the facebook 2021 hackercup. Secured a rank of 8700 out of 25000+ participant',
            date : 'sept 20, 2021',
            field : 'Conputer Science',
            image : 'https://static.dezeen.com/uploads/2021/11/meta-facebook-rebranding-name-news_dezeen_2364_col_hero2.jpg'
        },
        {
            id : 3,
            title : 'Gssoc-Mentor',
            details : 'GirlScript Foundation is a Non-profit registered by Government of India, has come up with a unique and Indias first tech oriented technical festival.',
            date : 'march 20, 2022',
            field : 'computer Science',
            image : 'https://cdn-images-1.medium.com/max/1200/1*ZfYWXN0zA6TqQQ7wGNJUOg.jpeg'
        },
        {
            id : 3,
            title : 'Contributor-Gwoc',
            details : 'Was an active contributor in the girlscript winter of contributor.My domains included front-end web development and UI/UX design.',
            date : 'sept 20, 2021',
            field : 'computer Science',
            image : 'https://cdn-images-1.medium.com/max/1200/1*ZfYWXN0zA6TqQQ7wGNJUOg.jpeg'
        },
        // {
        //     id : 4,
        //     title : 'Gssoc-Mentor',
        //     details : 'GirlScript Foundation is a Non-profit registered by Government of India, has come up with a unique and Indias first tech oriented technical festival.',
        //     date : 'march 20, 2022',
        //     field : 'computer Science',
        //     image : 'https://cdn-images-1.medium.com/max/1200/1*ZfYWXN0zA6TqQQ7wGNJUOg.jpeg'
        // },
        

    ]
}


// Do not remove any fields.
// Leave it blank instead as shown below.

/*

export const achievementData = {
    bio : "",
    achievements : []
}

*/